import authAxios from 'src/modules/shared/axios/authAxios';
import { AuthToken } from 'src/modules/auth/authToken';
import AuthCurrentTenant from 'src/modules/auth/authCurrentTenant';
import AuthInvitationToken from 'src/modules/auth/authInvitationToken';
import { tenantSubdomain } from '../tenant/tenantSubdomain';

export default class AuthService {
  static async sendEmailVerification() {
    const response = await authAxios.post(
      '/auth/send-email-address-verification-email',
      {
        tenantId: tenantSubdomain.isSubdomain
          ? AuthCurrentTenant.get()
          : undefined,
      },
    );

    return response.data;
  }

  static async sendPasswordResetEmail(email) {
    const response = await authAxios.post(
      '/auth/send-password-reset-email',
      {
        email,
        tenantId: tenantSubdomain.isSubdomain
          ? AuthCurrentTenant.get()
          : undefined,
      },
    );

    return response.data;
  }

  static async registerWithEmailAndPasswordTeam(
    email,
    password,
    firstName,
    lastName,
    occupation,
    phoneNumber,
    affiliateRefData,
    userType,
    code
  ) {
    const invitationToken = AuthInvitationToken.get();

    const response = await authAxios.post('/auth/team-sign-up', {
      email,
      password,
      invitationToken,
      tenantId: tenantSubdomain.isSubdomain
        ? AuthCurrentTenant.get()
        : undefined,
      firstName,
      lastName,
      occupation,
      phoneNumber,
      affiliateRefData,
      userType,
      code,
    });

    AuthInvitationToken.clear();

    return response.data;
  }
  static async userStatus(
    email,
  ) {
    const invitationToken = AuthInvitationToken.get();

    const response = await authAxios.post('/auth/status', {
      email,
    });

    AuthInvitationToken.clear();

    return response.data;
  }

  static async raytheonInvite(
    email,
  ) {
    const invitationToken = AuthInvitationToken.get();

    const response = await authAxios.post('/auth/raytheon-invite', {
      email,
    });

    AuthInvitationToken.clear();

    return response.data;
  }

  static async kmInvite(
    email,
  ) {
    const invitationToken = AuthInvitationToken.get();

    const response = await authAxios.post('/auth/krauss-invite', {
      email,
    });

    AuthInvitationToken.clear();

    return response.data;
  }

  static async suasInvite(
    email,
  ) {
    const invitationToken = AuthInvitationToken.get();

    const response = await authAxios.post('/auth/suas-af-invite', {
      email,
    });

    AuthInvitationToken.clear();

    return response.data;
  }

  static async workspaceInviteLogin(
    email,
    tenantId,
  ) {
    const invitationToken = AuthInvitationToken.get();

    const response = await authAxios.post('/auth/workspace-invite-login', {
      email,
      tenantId,
    });

    AuthInvitationToken.clear();

    return response.data;
  }

  static async raytheonLogin(
    email,
  ) {
    const invitationToken = AuthInvitationToken.get();

    const response = await authAxios.post('/auth/raytheon-login', {
      email,
      invitationToken,
    });

    AuthInvitationToken.clear();

    return response.data;
  }
  static async suasAFLogin(
    email,
    tenantId,
  ) {
    const invitationToken = AuthInvitationToken.get();

    const response = await authAxios.post('/auth/suas-af-login', {
      email,
      invitationToken,
      tenantId,
    });

    AuthInvitationToken.clear();

    return response.data;
  }
  static async registerWithEmailAndPassword(
    email,
    password,
    firstName,
    lastName,
    occupation,
    phoneNumber,
    affiliateRefData,
    userType,
    code,
    workspaceId,
  ) {
    const invitationToken = AuthInvitationToken.get();

    const response = await authAxios.post('/auth/sign-up', {
      email,
      password,
      invitationToken,
      tenantId: tenantSubdomain.isSubdomain
        ? AuthCurrentTenant.get()
        : undefined,
      firstName,
      lastName,
      occupation,
      phoneNumber,
      affiliateRefData,
      userType,
      code,
      workspaceId,
    });

    AuthInvitationToken.clear();

    return response.data;
  }
  static async signinWithEmailAndPassword(email, password) {
    const invitationToken = AuthInvitationToken.get();

    const response = await authAxios.post('/auth/sign-in', {
      email,
      password,
      invitationToken,
      tenantId: tenantSubdomain.isSubdomain
        ? AuthCurrentTenant.get()
        : undefined,
    });

    AuthInvitationToken.clear();

    return response.data;
  }

  static async fetchMe() {
    const response = await authAxios.get('/auth/me');
    return response.data;
  }

  static signout() {
    AuthToken.set(null, true);
  }

  static async updateProfile(data) {
    const body = {
      data,
    };

    const response = await authAxios.put(
      '/auth/profile',
      body,
    );

    return response.data;
  }

  static async changePassword(oldPassword, newPassword) {
    const body = {
      oldPassword,
      newPassword,
    };

    const response = await authAxios.put(
      '/auth/change-password',
      body,
    );

    return response.data;
  }

  static async passwordReset(token, password) {
    const response = await authAxios.put(
      '/auth/password-reset',
      {
        token,
        password,
        tenantId: tenantSubdomain.isSubdomain
          ? AuthCurrentTenant.get()
          : undefined,
      },
    );

    return response.data;
  }

  static async passwordResetWithCode(email, code, password) {
    const response = await authAxios.put(
      '/auth/password-reset-with-code',
      {
        email,
        code,
        password,
        tenantId: tenantSubdomain.isSubdomain
          ? AuthCurrentTenant.get()
          : undefined,
      },
    );

    return response.data;
  }

  static async verifyEmail(token) {
    const response = await authAxios.put(
      '/auth/verify-email',
      {
        token,
        tenantId: tenantSubdomain.isSubdomain
          ? AuthCurrentTenant.get()
          : undefined,
      },
    );

    return response.data;
  }

  static async socialOnboard() {
    const invitationToken = AuthInvitationToken.get();

    const response = await authAxios.post(
      '/auth/social/onboard',
      {
        invitationToken,
        tenantId: tenantSubdomain.isSubdomain
          ? AuthCurrentTenant.get()
          : undefined,
      },
    );

    AuthInvitationToken.clear();

    return response.data;
  }

  static isSocialOnboardRequested() {
    const urlParams = new URLSearchParams(
      window.location.search,
    );

    return Boolean(urlParams.get('social'));
  }


  static async workosOnboard() {
    const invitationToken = AuthInvitationToken.get();

    const response = await authAxios.post(
      '/workos/onboard',
      {
        invitationToken,
        tenantId: tenantSubdomain.isSubdomain
          ? AuthCurrentTenant.get()
          : undefined,
      },
    );


    AuthInvitationToken.clear();

    return response.data;
  }

  static isWorkosOnboardRequested() {
    const urlParams = new URLSearchParams(
      window.location.search,
    );

    return Boolean(urlParams.get('workos'));
  }

  static async clearWorkspaceOverride() {
    const response = await authAxios.post('/auth/clear-workspace-override');
    return response.data;
  }
}
